import React, { useEffect, useRef, useState } from 'react';
import { Rocket, Ticket, BadgeCheck, Crown } from 'lucide-react';
import { foundingBenefits } from '../mock';

const iconMap = { Rocket, Ticket, BadgeCheck };

const BenefitCard = ({ benefit, index, active }) => {
  const Icon = iconMap[benefit.icon];
  return (
    <div
      className="lift relative rounded-3xl border border-white/8 bg-gradient-to-b from-[#0d0d10] to-[#050506] p-8 overflow-hidden"
      style={{
        opacity: active ? 1 : 0,
        transform: active ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.7s ease ${index * 0.12}s, transform 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) ${index * 0.12}s`,
      }}
    >
      <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#39D353]/10 blur-3xl" />

      <div className="relative flex items-center gap-3 text-[#39D353]">
        <span className="text-[11px] tracking-[0.2em] uppercase font-semibold">
          Benefit 0{index + 1}
        </span>
      </div>

      <div className="relative mt-5 h-14 w-14 rounded-2xl bg-[#39D353] text-black flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(57,211,83,0.55)]">
        <Icon size={22} />
      </div>

      <h3 className="relative mt-6 text-2xl md:text-[26px] font-bold tracking-tight text-white">
        {benefit.title}
      </h3>
      <p className="relative mt-3 text-sm md:text-[15px] text-neutral-400 leading-relaxed">
        {benefit.description}
      </p>
    </div>
  );
};

const WaitlistCounter = () => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setActive(true),
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="founding-members"
      className="relative py-24 md:py-28 bg-[#050506] border-y border-white/5"
    >
      <div className="absolute inset-0 grid-lines opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#39D353]/10 border border-[#39D353]/25 text-[11px] tracking-[0.15em] uppercase text-[#39D353] font-semibold">
            <Crown size={12} />
            Founding members
          </div>

          <h2 className="mt-5 text-[clamp(2rem,4.5vw,3.5rem)] leading-[1.05] font-bold tracking-tight">
            <span className="text-white">A </span>
            <span className="neon-text italic">limited</span>
            <span className="text-white"> seat at the table.</span>
          </h2>

          <p className="mt-5 text-neutral-400 text-base md:text-lg leading-relaxed">
            Founding members get priority access, exclusive first-drop invitations, and a lifetime
            badge on their profile. Spots are limited.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6">
          {foundingBenefits.map((b, i) => (
            <BenefitCard key={b.title} benefit={b} index={i} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WaitlistCounter;
